<template>
  <div class="menu-item">
    <a class="hamburguer" href="#" @click="toggleMenu">
      <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/hamburguer.svg" width="40" height="40" :color="BLUE_COLOUR"/>
    </a>
    <transition name="fade" appear v-if="!dontDisplayDropdown">
      <div class="sub-menu" v-if="isOpen" v-click-outside="hideMenu">
        <div v-if="showLanguageSelector" class="menu-item-list">
          <lang-selector :enablePortuguese="enablePortuguese" style="margin: 0px !important" class="d-inline-block mr-4"></lang-selector>
					<hr>
				</div>
				<slot name="menu-items" class="menu-item-list"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import BaseModal from '../BaseModal.vue'
import LangSelector from '@/components/base/LangSelector'
import { LARGE_SIZE, MEDIUM_SIZE } from '@/constants/sizes'
import { BLUE_COLOUR } from '@/constants/colours'

export default {
  name: 'hamburguer-dropdown',
	vcoConfig: {
		middleware: this.processClickOutside
	},
  components: {
    BaseModal,
    LangSelector
  },
  props: {
    showLanguageSelector: {
      type: Boolean
    },
    enablePortuguese: Boolean,
    dontDisplayDropdown: Boolean
  },
  data () {
    return {
      isOpen: false,
      LARGE_SIZE,
      MEDIUM_SIZE,
			BLUE_COLOUR
    }
  },
	methods: {
		toggleMenu () {
			this.isOpen = !this.isOpen
			this.$store.dispatch('layout/toggleMenu')
		},
		hideMenu () {
			if (this.isOpen) {
				this.isOpen = false
			}
		},
		processClickOutside (event) {
			return this.isOpen && !(event.target.closest('.hamburguer'))
		}
	}
}
</script>

<style lang="scss" scoped>
nav .menu-item .title {
	font-weight: bold;
}
nav .menu-item svg {
  width: 10px;
}

nav .menu-item a.hamburguer svg {
  width: 100%;
}
nav .menu-item-list {
  margin:1.15rem;

	a {
		color: $blue;
		font-weight: bold;
	}
}

.btn.btn-dropdown:focus {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important; 
}

nav .menu-item .sub-menu {
	top: 4rem;
	left: -9rem;
  position: absolute;
  background-color: $white;
  width: max-content;
	padding: 1rem 2rem;
  z-index: 10;
  border-radius: $border-radius;
  box-shadow: $custom-shadow-bottom;
  /* height: 10rem; */
}
.fade-enter-active,
.fade-leave-active {
  transition: all .5s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.sub-menu hr {
	margin: {
		top: 0rem;
		bottom: 1rem;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/base/dropdown/HamburguerDropdown.vue